import { render, staticRenderFns } from "./ProjectsMenu.vue?vue&type=template&id=291ee608&"
import script from "./ProjectsMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports